import { FOOTER_COMPONENT_NAMES } from '@/components/public/footers/index'
import i18n from '@/plugins/i18n'
import { ABOGALITYPRO_PLATFORM_NAME } from '@/constants/platformNames'
import { PUBLIC_LAYOUT, PUBLIC_REDUCED_LAYOUT, PUBLIC_MENU_LAYOUT } from '@/constants/layouts'
import { ABOGALITYPRO_LOGO } from '@/constants/logosFileNames'

const layout = PUBLIC_LAYOUT
const footer = {
  component: FOOTER_COMPONENT_NAMES.ABOGALITYPRO
}
const logo = {
  src: ABOGALITYPRO_LOGO
}

const tagLine = 'Openlegal'

export default [
  {
    path: '/',
    name: 'Abogalitypro',
    component: () => import('@/components/views/abogalitypro/Home'),
    meta: {
      tagLine,
      title: {
        text () {
          return i18n.t('abogalitypro.title')
        }
      },
      tagLine: ABOGALITYPRO_PLATFORM_NAME,
      layout,
      footer,
      logo,
      i18n: 'public/views/abogalitypro'
    }
  },
  {
    path: 'terminos-condiciones-abogados',
    name: 'TermsLawyers',
    component: () => import('@/components/views/abogalitypro/TermsLawyers'),
    meta: {
      tagLine,
      title: {
        text () {
          return 'Términos y condiciones para abogados'
        }
      },
      layout: PUBLIC_REDUCED_LAYOUT,
      footer,
      logo
    }
  },
  {
    path: 'contact/success',
    name: 'ContactFormSuccessAbogalityPRO',
    component: () => import('@/components/views/CompaniesContactFormSuccess'),
    meta: {
      layout: PUBLIC_MENU_LAYOUT,
      i18n: 'forms/companies-contact-form.json'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/abogalitypro.routes.js